export class CsvColumnMapper {
  public toObjects<R extends Record<keyof R, string>>(data: string[][], columnSetting: CsvColumnSetting<R>): R[] {
    const objects = [] as R[];
    if(columnSetting == undefined || columnSetting.mapping == undefined) {
      return objects;
    }
    if(data.length == 0 || (data.length == 1 && columnSetting.hasHeader == true)) {
      return objects;
    }
    const startIndex = columnSetting.hasHeader ? 1: 0;
    for (let index = startIndex; index < data.length; index++) {
      const dataLine = data[index];
      const object = {} as Record<keyof R, string>;
      for(const key in columnSetting.mapping)
      {
        const columnIndex = columnSetting.mapping[key];
        if (columnIndex >= dataLine.length) {
          throw new Error('Column index is out of bounds');
        }
        object[key] = dataLine[columnIndex];
      }
      objects.push(object as R);
    }
    return objects;
  }
}

export type CsvColumnSetting<R> =
{
  hasHeader: boolean;
  mapping: Record<keyof R, number>
}
